<template>
  <div class="ecommerce-searchbar mt-1">
    <b-row>
      <b-col cols="12">
        <!-- Search input -->
        <b-input-group class="input-group-merge">
          <b-input-group-append is-text>
            <transition name="fade">
              <feather-icon
                v-if="filters.search == ''"
                icon="SearchIcon"
                size="18"
                class="text-muted"
              />
              <feather-icon
                v-else
                icon="XIcon"
                size="18"
                class="text-danger cursor-pointer"
                @click="filters.search = ''"
              />
            </transition>
          </b-input-group-append>
          <b-form-input
            v-model="filters.search"
            placeholder="Buscador por nombre"
            class="search-product"
          />
        </b-input-group>

        <div class="text-right">
          <b-badge class="mt-1">
            {{ filters.contenido.text +' | '+ timestampToDate(filters.ciclo.fecha_ini, 'MMMM YYYY') +' - '+ timestampToDate(filters.ciclo.fecha_fin, 'MMMM YYYY') }}
          </b-badge>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import { nombreModalidad, timestampToDate } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BBadge,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nombreModalidad,
      timestampToDate,
    }
  },
}
</script>
